import React from 'react'

const ICON = {
    width: "16",
    height: "16",
    colors: {
        candidate: "#0D7AB6",
        company: "#87D72A"
    }
};

const IconLocation = ({ iconType }) => {
    return(      
    <svg width={ICON.width} height={ICON.height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M8.2 8.13495C6.95707 8.13495 5.9498 7.14173 5.9498 5.9164C5.9498 4.6913 6.95707 3.69808 8.2 3.69808C9.44282 3.69808 10.4502 4.6913 10.4502 5.9164C10.4502 7.14173 9.44282 8.13495 8.2 8.13495ZM8.2 1C5.32812 1 3 3.29515 3 6.12647C3 9.15363 8.2 15 8.2 15C8.2 15 13.4 9.37858 13.4 6.12647C13.4 3.29515 11.0719 1 8.2 1V1Z" fill={iconType === "candidate" ? ICON.colors.candidate : ICON.colors.company }/>
    </svg>
    )
};

export default IconLocation;
